document.addEventListener('DOMContentLoaded', function() {
  const mailchimpForm = document.getElementById('mailchimp-newsletter-form');
  
  if (mailchimpForm) {
    mailchimpForm.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const email = document.getElementById('newsletter-email').value.trim();
      const submitButton = document.getElementById('newsletter-submit');
      const messageDiv = document.getElementById('newsletter-message');
      
      // Clear previous messages
      messageDiv.innerHTML = '';
      
      // Validate email before submission
      if (!email) {
        showMessage('error', 'Please enter your email address.');
        return;
      }
      
      // Basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        showMessage('error', 'Please enter a valid email address.');
        return;
      }
      
      // Show loading state with spinner
      submitButton.disabled = true;
      submitButton.innerHTML = '<div class="loading-spinner"></div>';
      submitButton.setAttribute('aria-label', 'Subscribing...');
      submitButton.style.display = 'flex';
      submitButton.style.alignItems = 'center';
      submitButton.style.justifyContent = 'center';
      messageDiv.innerHTML = '';
      
            
      // Your specific Mailchimp form action URL
      const mailchimpURL = 'https://ladybirdnursery.us5.list-manage.com/subscribe/post?u=8b13d6a6057654f5a341051f6&id=d12a586f2a&f_id=000bb8edf0';
      
      // Create form data for Mailchimp
      const formData = new FormData();
      formData.append('EMAIL', email);
      formData.append('b_8b13d6a6057654f5a341051f6_d12a586f2a', ''); // Bot protection field
      
      // Submit to Mailchimp using JSONP to avoid CORS issues
      const callbackName = 'mailchimpCallback' + Math.floor(Math.random() * 1000000);
      
      // Handle timeout first
      const timeout = setTimeout(function() {
        if (window[callbackName]) {
          showMessage('error', 'The request timed out. Please try again.');
          resetButton();
          cleanup();
        }
      }, 5000); // 10 second timeout
      
      // Cleanup function
      function cleanup() {
        clearTimeout(timeout);
        const script = document.querySelector('script[src*="' + callbackName + '"]');
        if (script && script.parentNode) {
          script.parentNode.removeChild(script);
        }
        if (window[callbackName]) {
          delete window[callbackName];
        }
      }
      
      // Set up callback function
      window[callbackName] = function(data) {
        try {
          if (data.result === 'success') {
            // Use Mailchimp's success message if available, otherwise use default
            const successMessage = data.msg || 'Thank you for subscribing!';
            showMessage('success', successMessage);
            document.getElementById('newsletter-email').value = '';
          } else {
            // Show the exact Mailchimp error message
            let errorMessage = data.msg || 'There was an error subscribing to our newsletter.';
            
            // Clean up the message slightly but keep it recognizable
            errorMessage = errorMessage
              .replace(/\d+ - /, '') // Remove error codes like "400 - "
              .replace(/<[^>]*>/g, '') // Remove HTML tags
              .trim();
            
            showMessage('error', errorMessage);
          }
        } catch (e) {
          showMessage('error', 'An unexpected error occurred. Please try again.');
        }
        
        resetButton();
        cleanup();
      };
      
      // Create JSONP request
      const script = document.createElement('script');
      const params = new URLSearchParams();
      params.append('EMAIL', email);
      params.append('b_8b13d6a6057654f5a341051f6_d12a586f2a', ''); // Bot protection field
      params.append('c', callbackName);
      
      script.src = mailchimpURL.replace('/post?', '/post-json?') + '&' + params.toString();
      
      // Handle script load errors
      script.onerror = function() {
        showMessage('error', 'Unable to connect to our newsletter service. Please check your internet connection and try again.');
        resetButton();
        cleanup();
      };
      
      document.head.appendChild(script);
    });
  }
  
  function showMessage(type, message) {
    const messageDiv = document.getElementById('newsletter-message');
    messageDiv.innerHTML = `
      <div class="newsletter-message newsletter-message--${type}">
        ${message}
      </div>
    `;
  }
  
  function resetButton() {
    const submitButton = document.getElementById('newsletter-submit');
    submitButton.disabled = false;
    submitButton.removeAttribute('style'); // Remove inline styles
    submitButton.setAttribute('aria-label', 'Subscribe');
    submitButton.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_71_3879)">
          <path d="M12 18H5C4.46957 18 3.96086 17.7893 3.58579 17.4142C3.21071 17.0391 3 16.5304 3 16V6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4H19C19.5304 4 20.0391 4.21071 20.4142 4.58579C20.7893 4.96086 21 5.46957 21 6V13.5" stroke="#495920" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3 6L12 12L21 6" stroke="#495920" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M15 18H21" stroke="#495920" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M18 15L21 18L18 21" stroke="#495920" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0_71_3879">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    `;
  }
});